import { attachGameGroupId } from './deeplink';

/** 下单后跳转 Payment 页，payload 内附带 gid */
export function serializePaymentPayload(data, gameGroupId) {
  return JSON.stringify(attachGameGroupId(data, gameGroupId));
}

export function paymentRoute(data, gameGroupId) {
  return {
    name: 'Payment',
    params: { data: serializePaymentPayload(data, gameGroupId) },
  };
}

export function pushPayment(router, data, gameGroupId) {
  router.push(paymentRoute(data, gameGroupId));
}
